export default __webpack_public_path__ + "static/media/login-side-bg.41501d10.jpg";